export const es = {
  // Menu
  Home: "Inicio",
  HOME: "INICIO",
  Services: "Servicios",
  SERVICES: "SERVICIOS",
  "SW Development": "Desarrollo",
  "SW DEVELOPMENT": "DESARROLLO",
  "IT Consultancy": "Consultoria IT",
  "IT CONSULTANCY": "CONSULTORIA IT",
  "Cloud Services": "Servicios de Nube",
  "CLOUD SERVICES": "SERVICIOS DE NUBE",
  "Our Work": "Trabajo",
  "OUR WORK": "TRABAJO",
  Experiences: "Experiencia",
  EXPERIENCES: "EXPERIENCIA",
  SKILLS: "HABILIDADES",
  "About Us": "Acerca de",
  "ABOUT US": "ACERCA DE",
  "About Toucan": "Acerca de Toucan",
  "ABOUT TOUCAN": "ACERCA DE TOUCAN",
  "Join Us!": "Sumáte!",
  "JOIN US": "SUMATE",
  "Send CV": "Enviar CV",
  "SEND CV": "ENVIAR CV",
  "Contact Us!": "Contactanos!",
  "CONTACT US!": "CONTACTANOS!",

  // Home
  "Fly even higher": "Vuela aún más alto",
  Toucan: "Toucan",
  " is a team of senior software engineers who":
    " es un equipo de Ingenieros en Software senior quienes",
  "enjoy looking for solutions.": "disfrutan encontrar soluciones.",
  "We know that behind a challenging problem, there’ll be a great opportunity to develop new skills, to improve ourselves and to add value to our team.":
    "Sabemos que detrás de un problema desafiante, se encuentra una gran oportunidad de aprender nuevas habilidades, adquirir conocimiento y de agregar valor a nuestro equipo.",
  "We love teamwork": "Nos encanta el trabajo en equipo,",
  " we enjoy spending some quality time with great professionals while we discover new technologies or tools.":
    ", disfrutamos pasar tiempo con excelentes profesionales mientras descubrimos nuevas tecnologías y nuevas herramientas.",
  "Become your best self": "Pensá en grande",
  We: "Nosotros",
  "work with some of the most popular cloud-native technologies":
    "trabajamos con las tecnologías de nube más populares",
  "and we are always keeping up with the new stuff.":
    "y siempre nos mantenemos actualizados.",
  "We work on projects that involves worldwide trend technologies that are changing our world.":
    "Trabajamos en proyectos que involucran tecnologías de punta y que están cambiando el mundo.",
  "We are so excited about the future":
    "Estamos muy entuciasmados por el futuro",
  ", and we want to be part of it.": ", y queremos ser parte de él.",
  "Join the teams that trust us":
    "Sumate a los equipos que ya confían en nosotros",
  SiteWhere: "SiteWhere",
  "50 Floor": "50 Floor",
  "More Info": "Más info",
  "We know about software": "Sabemos de Software",

  //SERVICES - sw development
  "Software Development": "Desarrollo de Software",
  "We are": "Nosotros somos",
  "engineers with 10 years of experience":
    "ingenieros con 10 años de experiencia",
  "in software development.": "en desarrollo de software.",
  "We’ve got a": "Tenemos un",
  "consolidated team": "equipo consolidado",
  "of highly": "formado por profesionales",
  "committed, responsible and motivated":
    "comprometidos, responsables y motivados",
  "professionals.": "",
  "We work": "Trabajamos",
  " hard to improve ourselves and": " para ser mejores y",
  "to exceed customer expectations.":
    "para superar las expectativas de nuestros clientes.",

  //SERVICES - IT consultancy
  "The skillset of our developers":
    "Las habilidades de nuestros desarrolladores",
  "is the result of": "son el resultado de",
  "many years of experience working in many different technologies":
    "muchos años de experiencia trabajando con distintas tecnologías",
  "and projects.": "y en diferentes proyectos.",
  "This makes it easy for us to catch up with your team very fast and to start":
    "Esto nos permite ponernos al día con su equipo de forma muy rápida y empezar",
  "solving issues straight away": "a ayudar inmediatamente",
  "We are ready to help you.": "Estamos listos para ayudarte.",
  "Temporary help in projects": "Ayuda temporal en proyectos",
  "Get access to skilled workforce ready to assist your team to meet deadlines.":
    "Profesionales experimentados listos para ayudar a tu equipo a cumplir metas.",
  "Adapt your current software systems to align with your new business goals.":
    "Adaptá tus sistemas para alcanzar nuevos objetivos de negocio.",
  "Get help specific tasks in the software development lifecycle (like analysis of user requirements, Risk Assessment, Testing and more).":
    "Obtén ayuda con tareas específicas del desarrollo de software, como análisis de requerimientos, Evaluación de Riegos, pruebas, y más.",
  "SW Development Outsourcing": "Tercerización del Desarrollo de SW",
  "Get more time to focus in your business and let us help you with your new Software Project.":
    "Enfocá tu tiempo en tu negocio, nosotros te ayudamos con tu Proyecto de Software.",
  "Keep track of your project’s progress and check software evolution with quality metrics.":
    "Controlá el avance del proyecto y comprobá la evolución con métricas de calidad.",
  "Get a competitive advantage to your Company getting your project done faster and better, using the last technologies on the market.":
    "Obtené una ventaja competitiva al tener tu proyecto listo en menos tiempo, usando las últimas tecnologías del mercado.",

  // SERVICES - Cloud Services
  Our: "Nuestros",
  "Cloud Architects": "Arquitectos de nube",
  "are trained for planning and completing all aspects of a":
    "están capacitados para planear y completar todos los aspectos de un",
  "successful migration process.": "proceso de migración exitoso.",
  "We design, build, deploy and support":
    "Nosotros diseñamos, construimos, desplegamos y brindamos soporte",
  "scalable and high reliability":
    "a soluciones escalables y de alta fiabilidad.",
  "solutions.": "",
  "Let us guide you through a": "Permitinos guiarte en un",
  "safe trip to the cloud.": "viaje seguro a la nube.",
  "Assess your app’s current state":
    "Evaluar el estado actual de su aplicación",
  "- Measure current performance levels.":
    "- Medimos los niveles actuales de rendimiento.",
  "- Get a detailed cost of infrastructure.":
    "- Obtenemos un costo detallado de infraestructura.",
  "- Evaluate your software architecture.":
    "- Evaluamos su arquitectura de software.",
  "Define migration goals": "Definir objetivos de migración",
  "- Reduce costs of infrastructure": "- Reducimos costos de infraestructura",
  "- Get access to enterprise-class technology fast":
    "- Acceso rápido a tecnología de tipo empresarial",
  "- Satisfy elastic business load": "- Escalar app para soportar más usuarios",
  "Create a migration strategy": "Crear una estrategia de migración",
  "- Perform any necessary refactoring to your app’s code":
    "- Realizamos las refactorizaciones necesarias a su aplicación",
  "- Plan your data migration ": "- Planificamos la migración de datos ",
  "- Chose cloud configuration": "- Usted elige la configuración de nube",
  "Get to work!": "A trabajar!",

  // OUR WORK - Experience
  "Company dedicated to the manufacture and installation of floors.":
    "Compañía dedicada a la fabricación e instalación de pisos.",
  "It’s located in United States and has many branch offices.":
    "Se encuentra en Estados Unidos y posee numerosas sucursales.",
  "We provide IT consulting services by making a team of highly-skilled developers available to the client who quickly joined their team and got started.":
    "Proporcionamos servicios de consultoría IT: creamos un equipo de profesionales con mucha experiencia que se sumó al equipo del cliente y empezó a ayudarlos de forma inmediata.",
  "Technologies used: Vue JS, Java, Kubernetes, Apache Kafka, Redis, PostgreSQL":
    "Technologías usadas: Vue JS, Java, Kubernetes, Apache Kafka, Redis, PostgreSQL",
  "Open Source IoT Platform which implements a micro services architecture.":
    "Plataforma IoT de Código Abierto con arquitectura de micro servicios.",
  "This architecture uses gRPC as an internal communication mechanism, and it uses Apache Kafka and Redis to provide a highly performance process pipeline.":
    "Esta arquitectura usa gRPC como mecanismo de comunicación interna, y Apache Kafka y Redis para proporcionar un proceso de tipo pipeline de alto rendimiento.",
  "This technology makes it possible to manage millions of devices and to process billions of events. SiteWhere is a highly scalable thanks to its micro services architecture, Kubernetes (for deployment) and Istio as Service Mesh. We provide IT consulting services by making a team of highly-skilled developers available to the client who helped solve problems and also recommended new approaches.":
    "Esta tecnología permite gestionar millones de dispositivos y procesar billones de eventos. SiteWhere es altamente escalable gracias a su arquitectura de microservicios, Kubernetes (para despliegue) e Istio como Service Mesh. Proporcionamos servicio de Consultoría IT disponibilizando al cliente un equipo de desarrolladores experimentados que ayudan a solucionar problemas y recomiendan nuevos enfoques.",
  "Technologies used: Java, kubernetes, MongoDB, PostgreSQL, Jaeger, Zookeeper, gRPC, MQTT, Apache Kafka, AWS, GKE, Google Cloud, Go.":
    "Technologías usadas: Java, kubernetes, MongoDB, PostgreSQL, Jaeger, Zookeeper, gRPC, MQTT, Apache Kafka, AWS, GKE, Google Cloud, Go.",
  "SiteWhere Enterprise Portal": "Portal Empresarial SiteWhere",
  "Website to sell SiteWhere Subscriptions.":
    "Página web para vender Suscripciones de SiteWhere.",
  "We started from a list of requirements from the client, we created a web design, we develop the frontend and the backend and we wrote unit test for both.":
    "Partimos de una lista de requerimientos del cliente, creamos un diseño web, desarrollamos el frontend y el backend. Incluimos pruebas unitarias en ambos.",
  "We used Spring Boot to create a REST API which implements a JWT HS256 service to provide authentication and authorization. We used Apache Zookeeper to provide resilience and reliability to the transactions. We also used WebSockets to improve the user experience in the website, for those events that required asynchronous confirmations.":
    "Utilizamos Spring Boot para crear una API REST que implementa un servicio JWT HS256 para proveer autenticación y autorización. Usamos Apache Zookeeper para proporcionar resiliencia y confiabilidad a las transacciones. Usamos WebSockets para mejorar la experiencia del usuario, para eventos que requieren confirmaciones asíncronas.",
  "Tecnologies used: Vue JS, Vuetify, Sass, TypeScript, Chargify, Zendesk, Java, Rest, Apache Kafka, Kubernetes, PostgreSQL.":
    "Tecnologías usadas: Vue JS, Vuetify, Sass, TypeScript, Chargify, Zendesk, Java, Rest, Apache Kafka, Kubernetes, PostgreSQL.",
  Professionalism: "Profesionalismo",
  "The Toucan team has done an amazing job in helping to build the core SiteWhere technologies and our customer-facing commercial offerings. Their developers are highly-motivated, easy to work with, and perform well as a team. Many of their developers have multiple complimentary skill sets, allowing them to take on end-to-end development tasks that would often require a larger group. A truly impressive team!":
    ' "El equipo de Toucan ha hecho un trabajo fantástico ayudando a contruir el core de la Plataforma SiteWhere y nuestros productos comerciales de cara al cliente. Sus desarrolladores están altamente motivados, es muy fácil trabajar con ellos, y tienen un muy buen rendimiento como equipo. Muchos de ellos tienen habilidades complementarias, y realizan muchas tareas para las cuales se requería un equipo más grande. Un equipo impresionante!" ',
  "Derek Adams": "Derek Adams",
  "Founder and Architect": "Fundador y Arquitecto",
  "SiteWhere Company": "SiteWhere Company",

  // OUR WORK - skills
  "Our skills": "Nuestras habilidades",

  // ABOUT US - About Toucan
  "Where Toucan is born?": "¿Dónde nace Toucan?",
  "The Toucan Project started in Colonia Benitez, a little town near Resistencia City (Chaco, Argentina). Here, there’s an Educational Nature Reserve, which has 10 hectares and it’s kept as a restricted area, so only a few persons can get in with research, control and surveillance purposes. The main goal is to preserve the animals, the trees and the ecological processes. In the Reserve, there are 280 vegetable species, different mammals, and 135 birds species. However, there are animals that leave the reserve and walk around the town, so George usually see monkeys, coatis, and a lot of different birds like woodpecker and Toucans in the trees in his backyard.":
    "El Proyecto Toucan nace en Colonia Benitez, un pequeño pueblo cerca de Resistencia (Chaco, Argentina). Aquí se encuentra una Reserva Natural Educativa, una zona restringida de 10 has, donde sólo unas pocas personas pueden entrar con fines de investigación, control y vigilancia. El principal objetivo es la preservación de los animales, los árboles y los procesos ecológicos. En la reserva, se encuentran 280 especies vegetales, diferentes mamíferos y 135 especies de aves. Sin embargo, muchos animales salen de la reserva y pasean en el pueblo, por ende, es usual para Jorge ver en su patio monos, coatís y un montón de aves como el Pájaro Carpintero y Tucanes.",
  "About the founder": "Acerca del fundador",
  "George is always fixing everything and he is a curious born. His passion about computers started when he was 16 years old, at high school, by the hand of the Computer Teacher. Which motivated him to become an Information Systems Engineer, and then to get a Ph. D. In Computer Science. In the meantime, he discover a new passion: teaching, so he’s also a teacher at the University.":
    "Jorge siempre está arreglando cosas y es un curioso nato. Su pasión por las computadoras empezó cuando tenía 16 años, en la secundaria, de la mano de su profesor de Computación. Esto lo motivó a convertirse en Ingeniero en Sistemas de Información, y luego a obtener un Ph. D. en Ciencias de la Computación. Durante su paso por la facultad, descubrió una nueva pasión: enseñar, y se convirtió en profesor.",
  "He’s work and life philosophy is ‘do it right, or don’t do it at all’, so every day, he works really hard to create the best software solution. But he can’t do it all by himself, so he has a great group of engineers who give their best at their job, and he fully trust them.":
    'Su filosofía de vida y de trabajo es: "dá lo mejor en todo lo que hagas", por ende trabaja todos los días para crear la mejor solución de software. Pero no puede hacer todo él sólo, por lo que cuenta con un grupo de ingenieros que dan todo de sí, en los que confía plenamente. ',
  "George’s life goal is to create a company known worldwide for its quality and reliable software and Toucan is his first step to achieve his dreams.":
    "El objetivo de jorge es crear una empresa conocida mundialmente por la calidad de su software, y Toucan es el primer paso para alcanzar ese sueño.",

  // ABOUT US - join us
  "Our team": "Nuestro equipo",
  "We are a group of developers who enjoy new challenges. But we also love to have lunch together, trying new food, telling stories, and eatings desserts. We are all chocolate lovers! And we always have ice cream in our refrigerator. We enjoy our time together.":
    "Somos un grupo de desarrolladores que disfruta nuevos desafios. Pero también disfrutamos almorzar juntos, contar anécdotas y comer helado.",
  Teamwork: "Trabajo en equipo",
  "We enjoy learning new things": "Aprendemos cosas nuevas",
  "Positive attitude and Enthusiasm": "Actitud positiva y entuciasmo",
  "Strong work ethic": "Fuerte ética de trabajo",
  "We help each other": "Nos ayudamos",
  "We look for the best solution": "Buscamos la mejor solución",
  Cooperation: "Cooperación",
  "Honesty and Integrity": "Honestidad e integridad",
  "We are motivated": "Estamos motivamos",
  "We are creative": "Somos creativos",
  "What we offer": "Qué ofrecemos",
  "We are in continuous growing so we always looking for a new talents. We know how important it is to be confortable at work, so we offer you:":
    "Estamos en continuo crecimiento, por ende siempre estamos buscando nuevos talentos. Sabemos lo importante que es el estar cómodo en el trabajo, por ello te ofrecemos:",
  "Challenging project": "Proyectos desafiantes",
  "Keeping up with the new stuff": "Nuevas tecnologías",
  "Nice ergonomic chairs": "Sillas ergonómicas",
  "Peaceful office": "Oficina silenciosa",
  "What we need": "Qué necesitamos",
  "Some of our current technical skills":
    "Alguna de nuestras habilidades técnicas actuales",
  "Swift, SwiftUI, Android": "Swift, SwiftUI, Android",
  "Go, Python": "Go, Python",
  "Microsoft Azure": "Microsoft Azure",
  "Extra desirable skills": "Habilidades extra:",
  "English language": "Inglés intermedio/avanzado",
  "Testing Skills": "Habilidades de tester",
  Jira: "Jira",
  Git: "Git",
  "Your Skills are not listed? Don’t worry! Get in touch! We’d love to hear about you!":
    "Tus habilidades no están en la lista? no te preocupes! Contactanos! Nos gustaría saber de vos!",

  // ABOUT US - send CV
  "Send us your CV!": "Envianos tu CV!",
  "Your First Name:": "Tu nombre:",
  "Your Last Name:": "Tu apellido:",
  "Your Mail:": "Tu correo:",
  "Tell us about you:": "Contanos de vos:",
  "Your LinkedIn:": "Tu LinkedIn:",
  Send: "Enviar",
  "Attach CV": "Adjuntá tu CV",

  // Contact us
  "Get in Touch!": "Contáctenos!",
  "Company Name:": "Nombre de su Empresa:",
  "Your Idea:": "Su idea:",
  "Thanks!": "Thanks!",
  "Please try again.": "Por favor, volvé a intentar.",
  Back: "Volver",

  // Footer
  Contact: "Contacto",
  "Us!": "",
  Find: "Encontranos",
  Here: "Aquí",
  "We are!": "Estamos!",
  "López y Planes 290": "López y Planes 290",
  "Resistencia, Chaco": "Resistencia, Chaco",
  Argentina: "Argentina",
  "contact@toucansoft.io": "contact@toucansoft.io",
  "Write Us": "Escribinos",
  "+54 9 362 4187441": "+54 9 362 4187441",
  "Toucan, All Rights Reserved": "Toucan, Todos los derechos reservados",
};
